import { createAsyncThunk } from '@reduxjs/toolkit'
import { getIDToken } from '../utils/AuthUtil'
import {
  addProjects,
  addClientProjects,
  showAddProjectModal,
  addProject,
  removeProject,
  showErrorMessage,
  updateSelectedProject,
} from '../actions/organization'
import { BASE_URL } from '../config'
import { RootState } from '../store'
import { fetchUserRecentFiles } from './filesService'

export const addProjectAsync = createAsyncThunk(
  'organization/addProject',
  async (
    payload: {
      clientName?: string
      clientId?: string
      projectName: string
      organizationId: number
    },
    { dispatch },
  ) => {
    let project: any = {
      name: payload.projectName,
      client_id: payload.clientId,
      organization_id: payload.organizationId,
    }
    if (payload.clientName) project['clientName'] = payload.clientName
    if (payload.clientId) project['client_id'] = payload.clientId

    return fetch(`${BASE_URL}/api/projects/create`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(project),
    })
      .then((response) => {
        if (!response.ok)
          return response.json().then((response) => {
            throw new Error(response.error)
          })
        return response.json()
      })
      .then((data) => {
        dispatch(showAddProjectModal(false))
        dispatch(addProject(data))
      })
      .catch((error) => {
        dispatch(showErrorMessage(error.message))
        console.error('Error during creating file: ', error)
      })
  },
)

export const fetchProjectsByClient = createAsyncThunk(
  'organization/fetchProjectsByClient',
  async (payload: { clientId?: string }, { dispatch }) => {
    fetch(`${BASE_URL}/api/projects/findAll`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        filterBy: [
          {
            name: 'client_id',
            value: payload?.clientId ? payload.clientId : null,
          },
        ],
      }),
    })
      .then((response) => {
        if (!response.ok)
          return response.json().then((response) => {
            throw new Error(response.error)
          })
        return response.json()
      })
      .then((data) => {
        dispatch(
          addClientProjects({ clientId: payload.clientId!, projects: data }),
        )
      })
      .catch((error) => {
        dispatch(
          addClientProjects({ clientId: payload.clientId!, projects: [] }),
        )
        console.error('Error during fetching projects: ', error)
      })
  },
)

export const fetchProjects = createAsyncThunk(
  'organization/fetchProjects',
  async (_, { dispatch }) => {
    fetch(`${BASE_URL}/api/projects/findAll`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok)
          return response.json().then((response) => {
            throw new Error(response.error)
          })
        return response.json()
      })
      .then((data) => {
        dispatch(addProjects(data))
      })
      .catch((error) => {
        dispatch(addProjects([]))
        console.error('Error during fetching projects: ', error)
      })
  },
)

export const deleteProjectAsync = createAsyncThunk(
  'organization/deleteProject',
  async (payload: { projectId: string }, { dispatch, getState }) => {
    const state = getState() as RootState
    const data = { id: payload.projectId }

    fetch(`${BASE_URL}/api/projects/delete`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch(removeProject(data))
        dispatch(updateSelectedProject())
        dispatch(fetchUserRecentFiles({ userId: state.auth.user?.id }))
      })
      .catch((error) => console.error('Error during deleting project: ', error))
  },
)
